import { render, staticRenderFns } from "./evaluate-detail.vue?vue&type=template&id=1b779644&scoped=true&"
import script from "./evaluate-detail.vue?vue&type=script&lang=js&"
export * from "./evaluate-detail.vue?vue&type=script&lang=js&"
import style0 from "./evaluate-detail.vue?vue&type=style&index=0&id=1b779644&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b779644",
  null
  
)

export default component.exports